import { render, staticRenderFns } from "./MicroDisk.vue?vue&type=template&id=ab87100a&scoped=true&"
import script from "./MicroDisk.vue?vue&type=script&lang=js&"
export * from "./MicroDisk.vue?vue&type=script&lang=js&"
import style0 from "./MicroDisk.vue?vue&type=style&index=0&id=ab87100a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab87100a",
  null
  
)

export default component.exports